import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpoints } from '../../hooks/index.js';
import { KevelBanners } from '../../Shared/KevelBanners/index.js';
export const SecondaryKevelBanners = ({ kevelAds }) => {
    const { isMobile } = useBreakpoints();
    return (_jsx(KevelBanners, { kevelAds: kevelAds, ga4SubFeature: "secondary_location", imageSizes: isMobile
            ? '(min-width: 420px) calc(66.76vw - 34px), calc(83vw - 30px)'
            : '(min-width: 1400px) 414px, 30.5vw' }));
};
//# sourceMappingURL=SecondaryKevelBanners.js.map